import React from 'react';
import MenuContainer from './MenuContainer';

class MenuScreen extends React.Component {

    public render() {
        return <MenuContainer />
    }

}

export default MenuScreen;